import React from 'react'
import PropTypes from 'prop-types'
import TokenLoginAction from 'components/Actions/TokenLogin'

const TokenLoginPage = ({ match }) => (
  <TokenLoginAction token={match.params.token} />
)

TokenLoginPage.propTypes = {
  match: PropTypes.object.isRequired
}

export default TokenLoginPage
